module.exports = __webpack_public_path__ + "static/media/chantal.2aa9cc14.JPG";